function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0.00375366C5.373 0.00375366 0 5.37675 0 12.0038C0 18.6308 5.373 24.0038 12 24.0038C18.627 24.0038 24 18.6308 24 12.0038C24 5.37675 18.627 0.00375366 12 0.00375366ZM10.75 16.5218L6.25 12.2028L7.646 10.7678L10.724 13.7048L16.829 7.48675L18.25 8.89575L10.75 16.5218Z"
});

function SvgSucceed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucceed);
export default __webpack_public_path__ + "static/media/succeed.829b8a65afe381531b98f9d52d6d83ee.svg";
export { ForwardRef as ReactComponent };